import './MapLegend.css'
import React from "react";
import {IonButton, IonContent, IonIcon} from "@ionic/react";
import {refresh} from "ionicons/icons";
import {EOperationType, operationsWithIconUrls} from "../../../models/utils/EOperationType";
import MapLegendItem from "./MapLegendItem";
import OperationLocalService from "../../../services/storage/localStorage/OperationLocalService";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Function called when the user clicks on a filter.
     * @param {EOperationType} filter Filter called.
     */
    onFilterClick: (filter?: EOperationType) => void,
}

/**
 * Display the items in the map legend.
 * Brings up the filter chosen by the user to the parent components.
 * @author Alizée Grand
 * @version 1.2
 * @creation 16/09/2021
 * @last_update 25/04/2022
 **/
class MapLegend extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        /**
         * Automatically generates the list of filters for the map based on the operations retrieved.
         * @return {JSX.Element[]}
         */
        const getFiltersItem = (): JSX.Element[] => {
            let filters: JSX.Element[] = [];
            for(let type in EOperationType) {
                const typeNumber = parseInt(type);
                if(!isNaN(typeNumber)) {
                    const item = (
                        <MapLegendItem
                            onClick={() => {
                                this.props.onFilterClick(typeNumber);
                            }}
                            iconUrl={operationsWithIconUrls[typeNumber].iconPath}
                            label={getTranslation(operationsWithIconUrls[typeNumber].translateKeyName)}
                            nbBadge={OperationLocalService.countOperationsByType(typeNumber)}
                        />
                    );
                    filters.push(item);
                }
            }
            return filters;
        }

        return (
            <IonContent color="secondary" id="legendContainer">
                <h1>{getTranslation("pages.map.legend.title")}</h1>

                <IonButton expand="full" onClick={() => {this.props.onFilterClick()}}>
                    <IonIcon icon={refresh}/>
                    {getTranslation("pages.map.legend.button-show-all")}
                </IonButton>
                {
                    getFiltersItem().map((item, key) => (
                        <div key={key}>
                            {item}
                        </div>
                    ))
                }

            </IonContent>
        );
    }
}


export default withTranslation()(MapLegend);
